import React, { useCallback, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiGift } from 'react-icons/fi';
import { getPolicyCommercialGesture } from '../../../services/api';
import { parseCgError, unwrapCgData } from './commercialGestureUtils';
import { useCommercialGesturePermissions } from './CommercialGestureShared';

/**
 * Bouton d’accès au geste commercial d’une police (header fiche police).
 * Masqué hors périmètre Standard (403) ou sans droit de lecture.
 */
const PolicyCommercialGestureButton = ({ policyId, policyPreview }) => {
    const navigate = useNavigate();
    const { canRead } = useCommercialGesturePermissions();
    const [gesture, setGesture] = useState(null);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(Boolean(policyId && canRead));

    const load = useCallback(async () => {
        if (!policyId || !canRead) {
            setVisible(false);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const data = unwrapCgData(await getPolicyCommercialGesture(policyId));
            setGesture(data);
            setVisible(true);
        } catch (err) {
            const parsed = parseCgError(err);
            if (parsed.status === 403 || parsed.code === 'POLICY_OUT_OF_STANDARD_SCOPE') {
                setVisible(false);
                setGesture(null);
            } else if (parsed.status === 404 || parsed.code === 'COMMERCIAL_GESTURE_NOT_FOUND') {
                setGesture(null);
                setVisible(true);
            } else {
                setVisible(true);
                setGesture(null);
            }
        } finally {
            setLoading(false);
        }
    }, [policyId, canRead]);

    useEffect(() => { load(); }, [load]);

    if (!visible) return null;

    const handleClick = () => {
        if (gesture?.id) {
            navigate(`/admin/trips/commercial-gestures/${gesture.id}`);
            return;
        }
        navigate('/admin/trips/commercial-gestures/new', {
            state: { policy: policyPreview || { policy_id: policyId } },
        });
    };

    return (
        <Button variant="outline-primary" onClick={handleClick} disabled={loading}>
            {loading ? (
                <Spinner size="sm" className="me-2" animation="border" />
            ) : (
                <FiGift className="me-2" aria-hidden="true" />
            )}
            Geste commercial
        </Button>
    );
};

export default PolicyCommercialGestureButton;
